// @ts-nocheck
/**
 * White Label Influencer Presentation
 *
 * PRIVATE URL - Not publicly accessible
 * For showing to potential white-label partners only
 *
 * URL: /wl-partner-deck
 */

import React, { useEffect } from 'react';

const WhiteLabelPresentation: React.FC = () => {
  useEffect(() => {
    // Redirect to the full HTML presentation
    window.location.href = '/influencer-assets/presentation.html';
  }, []);

  return (
    <div style={{
      width: '100vw',
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#000',
      color: '#fff',
      fontFamily: 'Inter, sans-serif'
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '24px', marginBottom: '20px' }}>Loading White Label Presentation...</div>
        <div style={{ fontSize: '14px', opacity: 0.7 }}>If you are not redirected automatically, <a href="/influencer-assets/presentation.html" style={{ color: '#00ffe7' }}>click here</a></div>
      </div>
    </div>
  );
};

export default WhiteLabelPresentation;
